export default __webpack_public_path__ + "static/media/AssetCollection.afcd2a75.svg";